"use strict";

exports.__esModule = true;
exports.TYPES = exports.SIZES = void 0;
let SIZES = exports.SIZES = /*#__PURE__*/function (SIZES) {
  SIZES["SMALL"] = "small";
  SIZES["NORMAL"] = "normal";
  return SIZES;
}({});
let TYPES = exports.TYPES = /*#__PURE__*/function (TYPES) {
  TYPES["COLORED"] = "colored";
  TYPES["NEUTRAL"] = "neutral";
  return TYPES;
}({});